import { i18n } from "vue-lang-router";

export class Location {
  ref?: string;
  name?: string;
  company?: string;
  description?:string
  street?: any;
  city?: string;
  postCode?: string;
  country?: string;
  email?:string;
  latlng?: any;
  distance?: number;
  openingTimes?: any;
  phone?: string | "";
  firstName?: string;
  lastName?: string;

  public static of(data: any): Location {

    const l: Location = new Location();
    l.ref = data.location_ref
    l.name = data.location_name;
    l.street = data.location_address.houseNumber + " " + data.location_address.street;
    l.city = data?.location_address.city;
    l.postCode = data?.location_address.postalCode;
    l.country = data?.location_address.country;
    l.latlng = { lat: data?.location_address.latitude, lng: data?.location_address.longitude };
    l.description = data?.location_description;
    l.email = data?.location_email;
    l.phone = data?.location_phone;


    if(data.location_opening_times) {
      const openingTimes = data.location_opening_times
      const date = new Date();
      const day = date.getDay();
      const dimanche = openingTimes.sunday?openingTimes.sunday.join(' / '): "";
      const lundi =  openingTimes.monday?openingTimes.monday.join(' / '): "";
      const mardi = openingTimes.tuesday?openingTimes.tuesday.join(' / '): "";
      const mercredi = openingTimes.wednesday?openingTimes.wednesday.join(' / '):"";
      const jeudi = openingTimes.thursday?openingTimes.thursday.join(' / '):"";
      const vendredi = openingTimes.friday?openingTimes.friday.join(' / '):"";
      const samedi = openingTimes.saturday?openingTimes.saturday.join(' / '):"";
      l.openingTimes = [
        {
          now: (day === 1),
          day: "Monday",
          time: lundi ? lundi : i18n.t("Close"),
        },
        {
          now: (day === 2),
          day: "Tuesday",
          time: mardi ? mardi : i18n.t("Close"),
        },
        {
          now: (day === 3),
          day: "Wednesday",
          time: mercredi ? mercredi : i18n.t("Close"),
        },
        {
          now: (day === 4),
          day: "Thursday",
          time: jeudi ? jeudi : i18n.t("Close"),
        },
        {
          now: (day === 5),
          day: "Friday",
          time: vendredi ? vendredi : i18n.t("Close"),
        },
        {
          now: (day === 6),
          day: "Saturday",
          time: samedi ? samedi : i18n.t("Close"),
        },
        {
          now: (day === 0),
          day: "Sunday",
          time: dimanche ? dimanche : i18n.t("Close"),
        },
      ];
    }
    return l;
  }
}

export class hereAddress {
  street?: string;
  postCode?: string;
  city?: string;
  country?: string;

  public static of(data: any): hereAddress {
    let countries;
    // eslint-disable-next-line prefer-const
    countries = require("@/models/country.json");
    const address: hereAddress = new hereAddress();

    address.street = data.street;
    address.postCode = data.postalCode;
    address.city = data.city;
    address.country = countries.find(country => country.name === data.countryName).code || "";
    return address;
  }

}